// Периоды для виджетов дашборда, которые принимают `month`.
// short — подпись на переключателе, label — подпись в карточках («Выручка · За год»).
export const periods = [
  { id: 1, short: "Месяц", label: "За месяц" },
  { id: 3, short: "3 мес", label: "За 3 месяца" },
  { id: 6, short: "6 мес", label: "За полгода" },
  { id: 12, short: "Год", label: "За год" },
  { id: 60, short: "5 лет", label: "За 5 лет" },
];

export const DEFAULT_PERIOD = 12;

export const getPeriodLabel = (month: number) => periods.find((p) => p.id === month)?.label || `За ${month} мес.`;

/** Период из URL (?month=6), если он есть среди допустимых. */
export const readPeriodFromUrl = (): number => {
  const value = Number(new URLSearchParams(window.location.search).get("month"));
  return periods.some((p) => p.id === value) ? value : DEFAULT_PERIOD;
};
